module.exports = __webpack_public_path__ + "static/media/align-right.49c59f6e.svg";